var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"action",attrs:{"color":"error","icon":"","outlined":"","elevation":"3"},on:{"click":function($event){return _vm.remove()}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-delete ")])],1)]}}])},[_c('span',[_vm._v("Excluir item")])]),_c('confirm-modal',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }